export const STATUS_NEW = 0;
export const STATUS_PENDING = 1;
export const STATUS_RESOLVED = 2;
export const STATUS_REOPENED = 3;

export const STATUS_NEW_ID = 0;
export const STATUS_OPEN_ID = 1;
export const STATUS_CLOSED_ID = 2;
export const STATUS_REOPEN_ID = 3;

export const STATUS_NEW_LABEL = 'New';
export const STATUS_OPEN_LABEL = 'Open';
export const STATUS_CLOSED_LABEL = 'Closed';
export const STATUS_REOPEN_LABEL = 'Reopen';

export const STATUS_NEW_VALUE = 'new';
export const STATUS_OPEN_VALUE = 'open';
export const STATUS_CLOSED_VALUE = 'resolved';

export const STATUS_DONE_VALUE = 'DONE';
export const STATUS_START_VALUE = 'START';
